module.exports = __webpack_public_path__ + "static/media/brand-refresh-arrow-right.660f9081.svg";